export type AromaticIcon = {
  categoryCode: string;
  icon: string;
};

// prettier-ignore
const aromatics: AromaticIcon[] = [
  { categoryCode: 'capsule-aromatic', icon: '24/coffeenote/flowery' },
  { categoryCode: 'capsule-aromatic-alcohol', icon: '24/coffeenote/alcohol' },
  { categoryCode: 'capsule-aromatic-almond', icon: '24/coffeenote/almonds' },
  { categoryCode: 'capsule-aromatic-almonds', icon: '24/coffeenote/almonds' },
  { categoryCode: 'capsule-aromatic-amaretti', icon: '24/coffeenote/amaretti' },
  { categoryCode: 'capsule-aromatic-baked-apple-flavors', icon: '24/coffeenote/baked-apple' },
  { categoryCode: 'capsule-aromatic-balance', icon: '24/coffeenote/balance' },
  { categoryCode: 'capsule-aromatic-balanced', icon: '24/coffeenote/balance' },
  { categoryCode: 'capsule-aromatic-balanced-b2b', icon: '24/coffeenote/balance' },
  { categoryCode: 'capsule-aromatic-bergamot', icon: '24/coffeenote/bergamot' },
  { categoryCode: 'capsule-aromatic-berry', icon: '24/coffeenote/berry' },
  { categoryCode: 'capsule-aromatic-biscuit', icon: '24/coffeenote/biscuit' },
  { categoryCode: 'capsule-aromatic-biscuit-notes-apple-crumble', icon: '24/coffee/coffee-aroma' },
  { categoryCode: 'capsule-aromatic-biscuity', icon: '24/coffeenote/biscuit' },
  { categoryCode: 'capsule-aromatic-blueberry', icon: '24/coffeenote/blueberry' },
  { categoryCode: 'capsule-aromatic-bold-roasted-notes', icon: '24/coffeenote/intense-roasted' },
  { categoryCode: 'capsule-aromatic-bready-nutty', icon: '24/coffee/coffee-aroma' },
  { categoryCode: 'capsule-aromatic-breakfast-selection', icon: '24/coffee/coffee-aroma' },
  { categoryCode: 'capsule-aromatic-brown-sugar-and-roasted-notes', icon: '24/coffeenote/sugar' },
  { categoryCode: 'capsule-aromatic-candied-fruit', icon: '24/coffeenote/candied-fruit' },
  { categoryCode: 'capsule-aromatic-candy-sweet', icon: '24/coffeenote/sugar' },
  { categoryCode: 'capsule-aromatic-caramel', icon: '24/coffeenote/caramel' },
  { categoryCode: 'capsule-aromatic-caramelized', icon: '24/coffeenote/caramel' },
  { categoryCode: 'capsule-aromatic-caramellynotes-b2b', icon: '24/coffeenote/caramel' },
  { categoryCode: 'capsule-aromatic-cardamom', icon: '24/coffenote/cardamom' },
  { categoryCode: 'capsule-aromatic-cereal', icon: '24/coffeenote/cereal' },
  { categoryCode: 'capsule-aromatic-cerealFruity', icon: '24/coffeenote/cereal' },
  { categoryCode: 'capsule-aromatic-chicory', icon: '24/coffeenote/vegetal' },
  { categoryCode: 'capsule-aromatic-chocolate', icon: '24/coffeenote/chocolate' },
  { categoryCode: 'capsule-aromatic-citric', icon: '24/coffeenote/citrus' },
  { categoryCode: 'capsule-aromatic-citrus', icon: '24/coffeenote/citrus' },
  { categoryCode: 'capsule-aromatic-cocktail', icon: '24/coffeenote/cocktail' },
  { categoryCode: 'capsule-aromatic-cocoa', icon: '24/coffeenote/cocoa' },
  { categoryCode: 'capsule-aromatic-cocoaGinger', icon: '24/coffeenote/ginger' },
  { categoryCode: 'capsule-aromatic-coconut', icon: '24/coffeenote/coconut' },
  { categoryCode: 'capsule-aromatic-dark-chocolate', icon: '24/coffeenote/chocolate' },
  { categoryCode: 'capsule-aromatic-delicate-toasted-biscuit-notes', icon: '24/coffeenote/sugar' },
  { categoryCode: 'capsule-aromatic-dry-vegetal', icon: '24/coffeenote/herbal' },
  { categoryCode: 'capsule-aromatic-exotic', icon: '24/coffeenote/tropical' },
  { categoryCode: 'capsule-aromatic-flavoured', icon: '24/coffee/coffee-aroma' },
  { categoryCode: 'capsule-aromatic-flavoured-b2b', icon: '24/coffee/coffee-aroma' },
  { categoryCode: 'capsule-aromatic-floral', icon: '24/coffeenote/flowery' },
  { categoryCode: 'capsule-aromatic-floralandWild', icon: '24/coffeenote/flowery' },
  { categoryCode: 'capsule-aromatic-floralJasmine', icon: '24/coffeenote/flowery' },
  { categoryCode: 'capsule-aromatic-flowery', icon: '24/coffeenote/flowery' },
  { categoryCode: 'capsule-aromatic-fruity', icon: '24/coffeenote/fruity' },
  { categoryCode: 'capsule-aromatic-fruity-b2b', icon: '24/coffeenote/fruity' },
  { categoryCode: 'capsule-aromatic-fruity-exotic', icon: '24/coffeenote/fruity' },
  { categoryCode: 'capsule-aromatic-fruityWiney', icon: '24/coffeenote/fruity' },
  { categoryCode: 'capsule-aromatic-ginger', icon: '24/coffeenote/ginger' },
  { categoryCode: 'capsule-aromatic-ginseng', icon: '24/coffeenote/ginseng' },
  { categoryCode: 'capsule-aromatic-hazelnut', icon: '24/coffeenote/hazelnut' },
  { categoryCode: 'capsule-aromatic-hazelnut-aromas', icon: '24/coffeenote/hazelnut' },
  { categoryCode: 'capsule-aromatic-herbal', icon: '24/coffeenote/herbal' },
  { categoryCode: 'capsule-aromatic-hintOfFruity', icon: '24/coffeenote/fruity' },
  { categoryCode: 'capsule-aromatic-hintsOfBitterCocoaPowderAndCereals', icon: '24/coffeenote/cocoa' },
  { categoryCode: 'capsule-aromatic-Honey', icon: '24/coffeenote/honey' },
  { categoryCode: 'capsule-aromatic-intense', icon: '24/coffeenote/intense' },
  { categoryCode: 'capsule-aromatic-intense-selection', icon: '24/coffeenote/intense' },
  { categoryCode: 'capsule-aromatic-juicy-fruity', icon: '24/coffeenote/fruity' },
  { categoryCode: 'capsule-aromatic-leather', icon: '24/coffeenote/leather' },
  { categoryCode: 'capsule-aromatic-lemon', icon: '24/coffeenote/citrus' },
  { categoryCode: 'capsule-aromatic-longRoasted', icon: '24/coffeenote/roasted' },
  { categoryCode: 'capsule-aromatic-malted', icon: '24/coffeenote/malted' },
  { categoryCode: 'capsule-aromatic-maltedCereal', icon: '24/coffeenote/malted' },
  { categoryCode: 'capsule-aromatic-malty', icon: '24/coffeenote/malted' },
  { categoryCode: 'capsule-aromatic-malty-b2b', icon: '24/coffeenote/malted' },
  { categoryCode: 'capsule-aromatic-malty-faintly-green-notes', icon: '24/coffeenote/malted' },
  { categoryCode: 'capsule-aromatic-maltyToasted', icon: '24/coffeenote/malted' },
  { categoryCode: 'capsule-aromatic-maple-syrup', icon: '24/coffeenote/syrup' },
  { categoryCode: 'capsule-aromatic-mild', icon: '24/coffee/coffee-aroma' },
  { categoryCode: 'capsule-aromatic-mild-cereal', icon: '24/coffeenote/cereal' },
  { categoryCode: 'capsule-aromatic-milk-selection', icon: '24/coffeenote/milky' },
  { categoryCode: 'capsule-aromatic-milky', icon: '24/coffeenote/milky' },
  { categoryCode: 'capsule-aromatic-nut', icon: '24/coffeenote/hazelnut' },
  { categoryCode: 'capsule-aromatic-nutty', icon: '24/coffeenote/hazelnut' },
  { categoryCode: 'capsule-aromatic-oak-wood', icon: '24/coffeenote/oak-wood' },
  { categoryCode: 'capsule-aromatic-orange-blossom', icon: '24/coffeenote/flowery' },
  { categoryCode: 'capsule-aromatic-pecan-nut', icon: '24/coffeenote/nut' },
  { categoryCode: 'capsule-aromatic-peppermint', icon: '24/coffeenote/peppermint' },
  { categoryCode: 'capsule-aromatic-peppery', icon: '24/coffeenote/spicy' },
  { categoryCode: 'capsule-aromatic-peppery-note', icon: '24/coffeenote/spicy' },
  { categoryCode: 'capsule-aromatic-pistachio', icon: '24/coffeenote/pistachio' },
  { categoryCode: 'capsule-aromatic-powerful', icon: '24/coffeenote/powerful-intense' },
  { categoryCode: 'capsule-aromatic-powerful-intense', icon: '24/coffeenote/powerful-intense' },
  { categoryCode: 'capsule-aromatic-praline-notes', icon: '24/coffeenote/nut' },
  { categoryCode: 'capsule-aromatic-pumpkin', icon: '24/coffeenote/pumpkin' },
  { categoryCode: 'capsule-aromatic-red-fruit', icon: '24/coffeenote/red-fruit' },
  { categoryCode: 'capsule-aromatic-redfruit', icon: '24/coffeenote/red-fruit' },
  { categoryCode: 'capsule-aromatic-RedFruit', icon: '24/coffeenote/red-fruit' },
  { categoryCode: 'capsule-aromatic-refreshing-mint', icon: '24/coffeenote/peppermint' },
  { categoryCode: 'capsule-aromatic-reminiscent-shortbread-cookies', icon: '24/coffeenote/biscuit' },
  { categoryCode: 'capsule-aromatic-rich', icon: '24/coffeenote/intense' },
  { categoryCode: 'capsule-aromatic-rich-b2b', icon: '24/coffeenote/intense' },
  { categoryCode: 'capsule-aromatic-ripe-fruits', icon: '24/coffeenote/fruity' },
  { categoryCode: 'capsule-aromatic-roasted', icon: '24/coffeenote/roasted' },
  { categoryCode: 'capsule-aromatic-roastedCereal', icon: '24/coffeenote/roasted' },
  { categoryCode: 'capsule-aromatic-roastedCocoa', icon: '24/coffeenote/roasted' },
  { categoryCode: 'capsule-aromatic-robusta', icon: '24/coffee/coffee-aroma' },
  { categoryCode: 'capsule-aromatic-smoky-notes', icon: '24/coffee/coffee-aroma' },
  { categoryCode: 'capsule-aromatic-smoky-wood', icon: '24/coffeenote/oak-wood' },
  { categoryCode: 'capsule-aromatic-smooth', icon: '24/coffeenote/balance' },
  { categoryCode: 'capsule-aromatic-smooth-b2b', icon: '24/coffeenote/balance' },
  { categoryCode: 'capsule-aromatic-strawberry', icon: '24/coffeenote/red-fruit' },
  { categoryCode: 'capsule-aromatic-spicy', icon: '24/coffeenote/spicy' },
  { categoryCode: 'capsule-aromatic-sugar', icon: '24/coffeenote/sugar' },
  { categoryCode: 'capsule-aromatic-sweet', icon: '24/coffeenote/sugar' },
  { categoryCode: 'capsule-aromatic-sweetCereal', icon: '24/coffeenote/cereal' },
  { categoryCode: 'capsule-aromatic-sweetCereal-b2b', icon: '24/coffeenote/cereal' },
  { categoryCode: 'capsule-aromatic-sweetnotes-b2b', icon: '24/coffeenote/caramel' },
  { categoryCode: 'capsule-aromatic-toasted-cereal', icon: '24/coffeenote/malted' },
  { categoryCode: 'capsule-aromatic-toffeenotes-b2b', icon: '24/coffeenote/caramel' },
  { categoryCode: 'capsule-aromatic-tropical', icon: '24/coffeenote/tropical' },
  { categoryCode: 'capsule-aromatic-vanilla', icon: '24/coffeenote/vanilla' },
  { categoryCode: 'capsule-aromatic-vanillaAlmonds', icon: '24/coffeenote/vanilla' },
  { categoryCode: 'capsule-aromatic-vanillaCardamom', icon: '24/coffeenote/vanilla' },
  { categoryCode: 'capsule-aromatic-vegetal', icon: '24/coffeenote/vegetal' },
  { categoryCode: 'capsule-aromatic-veryRoasted', icon: '24/coffeenote/roasted' },
  { categoryCode: 'capsule-aromatic-watermelon', icon: '24/coffeenote/watermelon' },
  { categoryCode: 'capsule-aromatic-whiskey', icon: '24/coffeenote/alcohol' },
  { categoryCode: 'capsule-aromatic-whiskey-flavor', icon: '24/coffeenote/alcohol' },
  { categoryCode: 'capsule-aromatic-whisky', icon: '24/coffeenote/alcohol' },
  { categoryCode: 'capsule-aromatic-whisky-flavour', icon: '24/coffeenote/alcohol' },
  { categoryCode: 'capsule-aromatic-white-chocolate', icon: '24/coffeenote/chocolate' },
  { categoryCode: 'capsule-aromatic-wide-selection', icon: '24/coffee/coffee-aroma' },
  { categoryCode: 'capsule-aromatic-winey', icon: '24/coffeenote/winey' },
  { categoryCode: 'capsule-aromatic-wood', icon: '24/coffeenote/oak-wood' },
  { categoryCode: 'capsule-aromatic-woody', icon: '24/coffeenote/oak-wood' }
];
export default aromatics;
